import { Component, Input, OnInit } from '@angular/core';
import { ToasterService } from '../toaster/toaster.service';
import { Toast } from '../toaster/toast.interface';
//import { Console } from 'console';

@Component({
    selector: 'app-toaster-container',
    template: `<app-toaster *ngFor="let toast of toasts; let i=index" [toast]="toast" [i]="i" (remove)="remove($event)"></app-toaster>`,
    styles: []
})
export class ToasterContainerComponent implements OnInit {
    toasts: Toast[]=[];//=[{type:"success",title:"",body:"",delay:0}];

    constructor(private toaster: ToasterService) { }

    ngOnInit() {
        debugger;   
        //var toast1:Toast={type:"success",title:"1222",body:"1222",delay:0};
        //toast.type="success";
        //this.toasts.push(toast1);

        this.toaster.toast$
            .subscribe(toast => {
                if(this.toasts.length==0)
                this.toasts = [toast, ...this.toasts];                
                setTimeout(() => this.toasts.pop(), toast.delay || 60000);
            });
    }

    remove(index: number) {
        this.toasts = this.toasts.filter((v, i) => i !== index);
    }
}